export default {"src":"/_next/static/media/Event2.8547fdde.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};